module.exports = __webpack_public_path__ + "static/media/C3Pay_Logo.8a2ca7e1.png";